module.exports = __webpack_public_path__ + "static/media/77e62351-de71-9568-29f4-87900592ed4e.07d40d89.jpg";